export enum Language {
    DE = 'de',
    EN = 'en'
}

export enum Caption {
    Wirtschaft = 'Wirtschaft',
    Coronavirus = 'Coronavirus',
    Bayern = 'Bayern',
    Sport = 'Sport',
    Newsletter = 'Newsletter',
    Kultur = 'Kultur',
    Wissen = 'Wissen',
    Netzwelt = 'Netzwelt',
    Nachrichten = 'Nachrichten',
    Deutschland = 'Deutschland & Welt'
}

export enum SocialMedia {
    Facebook = 'Facebook',
    Twitter = 'Twitter',
    Mail = 'Mail',
    Whatsapp = 'Whatsapp'
}

export enum Author {
    LinusLuering = 'Linus Lüring',
    SteffenKuehne = 'Steffen Kühne',
    LudwigSpitaler = 'Ludwig Spitaler'
}

export interface TextConfig {
    title: string;
    headline: string;
    description: string;
    mobileShareText?: string;
    twitterShareText?: string;
    mailShareText?: string;
    whatsappShareText?: string;
}

export interface PageConfig {
    caption?: Caption;
    keywords?: string[];
    authors: Author[];
    url: string;
    provideEn?: boolean;
    ATId: string;
    previewImage: string;
    headerImage: string;
}

export interface LayoutConfig {
    headerOverlay?: boolean;
    showAside?: boolean;
    showProgress?: boolean;
}

export interface NavbarSize {
    breakpoint: string;
    size: string;
}

export enum Navbar {
    SMALL,
    MEDIUM,
    LARGE
}

export enum Position {
    LEFT,
    RIGHT
}

export enum Layout {
    COLUMN = 'column',
    ROW = 'row'
}

export type UserConfig = Omit<PageConfig, 'url'> & { de: TextConfig; en: TextConfig } & LayoutConfig;

export type MainConfig = PageConfig & TextConfig & LayoutConfig;
